

var bind = require('function-bind');
var $TypeError = require('es-errors/type');

var $call = require('./functionCall');
var $actualApply = require('./actualApply');

/** @type {import('.')} */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};




//////////////////
// WEBPACK FOOTER
// ../node_modules/call-bind-apply-helpers/index.js
// module id = ../node_modules/call-bind-apply-helpers/index.js
// module chunks = 1